import { render } from "./CopyToClipboard.vue?vue&type=template&id=7d855d2f&scoped=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=7d855d2f&scoped=true&lang=css"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d855d2f"]])

export default __exports__